import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";
import {translate} from "react-i18nify";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as componentTypes from "../constants/componentTypes";
import * as handlers from "../constants/handlers";
import * as modelHelper from "../helpers/modelHelper";

const prepareBackupLocalDBFile = (action$) =>
    action$.pipe(
        ofType(actionTypes.PREPARE_FILE_BACKUP_LOCAL_DB),
        switchMap(({payload}) => {
            if (payload.path) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_EXPORT_LOCAL_DB,
                            params: {
                                path: payload.path
                            }
                        },
                        method: handlers.EXPORT_LOCAL_DB,
                        tabId: 0
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SERVER_SAVE_FILE_INFORMATION,
                    payload: {
                        downloadingFile: modelHelper.mapDownloadingFileToObject(
                            -3,
                            "REDLIKE_LOCAL_DATA_BACKUP",
                            "xlsx",
                            1
                        )
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PREPARE_FILE,
                        params: {
                            method: methods.METHOD_EXPORT_LOCAL_DB
                        }
                    },
                    method: handlers.PREPARE_FILE_BACKUP_LOCAL_DB,
                    tabId: 0
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_NO_TAB,
                        type: componentTypes.PROGRESS_BAR_MODAL
                    }
                }
            ];
        })
    );

const prepareLocalFile = (action$) =>
    action$.pipe(
        ofType(actionTypes.PREPARE_FILE_LOCAL),
        switchMap(({payload}) => {
            if (payload.path && payload.fileId) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_EXPORT_LOCAL_FILE,
                            params: {
                                fileId: payload.fileId,
                                path: payload.path
                            }
                        },
                        method: handlers.EXPORT_LOCAL_FILE,
                        tabId: 0
                    }
                ];
            }

            return [];
        })
    );

const startImportingData = (action$) =>
    action$.pipe(
        ofType(actionTypes.CUSTOM_DATA_IMPORTING_START),
        switchMap(({payload}) => {
            return [
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: true
                    }
                },
                {
                    type: actionTypes.CUSTOM_DATA_SAVE_PROGRESS,
                    payload: {
                        task: null,
                        progress: 0
                    }
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_SETTINGS_TAB,
                        type: componentTypes.IMPORT_DATA_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_IMPORT_CUSTOM_DATA,
                        params: {
                            formatName: payload.formatName,
                            files: payload.files,
                            options: payload.options
                        }
                    },
                    method: handlers.IMPORT_CUSTOM_DATA,
                    tabId: 0
                }
            ];
        })
    );

const abortImportingData = (action$) =>
    action$.pipe(
        ofType(actionTypes.CUSTOM_DATA_ABORT_IMPORTING),
        switchMap(() => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_ABORT_CUSTOM_DATA_IMPORTING
                    },
                    method: handlers.ABORT_CUSTOM_DATA_IMPORTING,
                    tabId: 0
                }
            ];
        })
    );

const deleteImportedData = (action$) =>
    action$.pipe(
        ofType(actionTypes.CUSTOM_DATA_DELETE_IMPORTED_DATA),
        switchMap(() => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_DELETE_IMPORTED_CUSTOM_DATA
                    },
                    method: handlers.DELETE_IMPORTED_CUSTOM_DATA,
                    tabId: componentTypes.MODAL_NO_TAB
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_NO_TAB,
                        type: componentTypes.LOADING_MODAL,
                        params: {
                            message: translate("helper.pleaseWait"),
                            onCancel: {
                                type: actionTypes.SKIP_WEBSOCKET_REQUEST,
                                payload: {
                                    tabId: componentTypes.MODAL_NO_TAB,
                                    method: handlers.DELETE_IMPORTED_CUSTOM_DATA
                                }
                            }
                        }
                    }
                }
            ];
        })
    );

const startImportingPriceData = (action$) =>
    action$.pipe(
        ofType(actionTypes.PRICE_DATA_IMPORTING_START),
        switchMap(({payload}) => {
            return [
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: true
                    }
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_SETTINGS_TAB,
                        type: componentTypes.IMPORT_PRICE_DATA_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_IMPORT_DATA,
                        params: {
                            path: payload.path
                        }
                    },
                    method: handlers.PRICING_IMPORT_DATA,
                    tabId: 0
                }
            ];
        })
    );

export default [
    prepareBackupLocalDBFile,
    prepareLocalFile,
    startImportingData,
    abortImportingData,
    deleteImportedData,
    startImportingPriceData
];
